import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthLogin from '../../containers/AuthLogin';
import Registration from '../../containers/Registration';
import RegistrationAddInfo from '../../containers/RegistrationAddInfo';
import RestorePassword from '../../containers/RestorePassword';
import ResetPassword from '../../containers/ResetPassword';
import classes from '../../utils/classes';
import './AuthFlow.scss';

const background = require('../../assets/images/AuthFlow/bg.png');
const logo = require('../../assets/images/AuthFlow/logo.png');

class AuthFlow extends Component {
  static isPrivate = false;
  static propTypes = {
    match: PropTypes
      .shape({ url: PropTypes.string.isRequired })
      .isRequired,
    history: PropTypes
      .shape({
        push: PropTypes.func.isRequired,
        location: PropTypes
          .shape({})
          .isRequired,
      })
      .isRequired,
    getClientToken: PropTypes.func.isRequired,
  };

  componentDidMount() {
    document
      .body
      .classList
      .add(classes.AUTH_FLOW_WRAPPER);
    this
      .props
      .getClientToken();
  }

  componentWillUnmount() {
    document
      .body
      .classList
      .remove(classes.AUTH_FLOW_WRAPPER);
  }

  render() {
    const {
      match, history: {
        location,
      },
    } = this.props;

    return (
      <div className="auth-flow">
        <div className="static-part">
          <div className="background-wrapper">
            <img src={background} alt="background" />
          </div>
          <div className="part-content">
            <div className="img-wrapper">
              <img src={logo} alt="company logo" />
            </div>
            <div className="sub-header">
              <span>Grow your business with powerful AI algorithms</span>
            </div>
          </div>
        </div>
        <div className="dynamic-part">
          <Switch location={location}>
            <Route path={`${match.url}/registration-info`} component={RegistrationAddInfo} />
            <Route path={`${match.url}/login`} component={AuthLogin} />
            <Route path={`${match.url}/registration`} component={Registration} />
            <Route path={`${match.url}/restore-password`} component={RestorePassword} />
            <Route path={`${match.url}/reset-password`} component={ResetPassword} />
            <Redirect exact from={`${match.url}/`} to={`${match.url}/login`} />
          </Switch>
        </div>
      </div>
    );
  }
}
export default AuthFlow;



// WEBPACK FOOTER //
// ./src/containers/AuthFlow/AuthFlow.js